import React, { useMemo, useState } from "react";
import "./style.scss";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import { ReactComponent as CoffeBean } from "src/Assets/Icons/coffeeBean.svg";
import { ReactComponent as Menu } from "src/Assets/Icons/menu.svg";
import { ReactComponent as History } from "src/Assets/Icons/history.svg";
import { ReactComponent as Logout } from "src/Assets/Icons/logout.svg";
import { ReactComponent as LogoSvg } from "src/Assets/Icons/logoNicchio.svg";
import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import { ReactComponent as Close } from "src/Assets/Icons/close.svg";
import Vendas from "../Vendas";
import Movimentacao from "../Movimentacao";
import Historico from "../Historico";
import Relatorio from "../Relatorio";
import RelatorioGeral from "../RelatorioGeral";
import Usuarios from "../Usuarios";

import { useNavigate } from "react-router-dom";
import { CustomInput } from "src/Components";
import { Button } from "src/Components/customInput";
import { isValid } from "../services/utils";
import showToast from "../services/toastyService";
import { PutApi, PutPass } from "../services/auth";

export default function Home({ darkMode, setDarkMode }) {
  const navigate = useNavigate();

  const userData = localStorage.getItem("userId");
  const user = JSON.parse(userData) || {};

  const [menu, setMenu] = useState(true);
  const [aba, setAba] = useState(1);
  const [titulo, setTitulo] = useState("Vendas");

  const [novaSenha, setNovaSenha] = useState("");
  const [senhaAtual, setSenhaAtual] = useState("");
  const [showPopup, setShowpoup] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  function AlterarSenha() {
    if (!isValid(novaSenha) || !isValid(user.id)) {
      showToast("warning", "Preencha todos os dados");
      return;
    }

    const data = {
      userId: user.id,
      newPassword: novaSenha,
      currentPassword: senhaAtual,
    };

    PutPass(data)
      .then((res) => {
        showToast("success", "Usuário Adicionado");
        setShowpoup(false);
      })
      .catch((error) => {
        const apiErrors = error?.response?.data?.errors;
        const msg =
          apiErrors && apiErrors.length > 0
            ? apiErrors[0].message
            : error?.response?.data?.message ||
              error.message ||
              "Erro desconhecido";
        setErrorMsg(msg);
      });
  }

  return (
    <div className="Home">
      {!darkMode && <div className="-fade" />}

      <button className="menuButton" onClick={() => setMenu(!menu)}>
        <Menu />
        menu
      </button>

      <div className="Content">
        <aside className={`menu ${menu ? "menuActive" : ""}`}>
          <div className="logo">
            <LogoSvg />
          </div>

          <button className="user" onClick={() => setShowpoup(true)}>
            {user.email}
          </button>

          <button
            className={`menuItem ${aba === 1 ? "active" : ""}`}
            onClick={() => {
              setAba(1);
              setTitulo("Vendas");
            }}
          >
            <span>Vendas</span>
          </button>
          <button
            className={`menuItem ${aba === 2 ? "active" : ""}`}
            onClick={() => {
              setAba(2);
              setTitulo("Movimentações Bancárias");
            }}
          >
            <span>Movimentações Bancárias</span>
          </button>
          <button
            className={`menuItem ${aba === 3 ? "active" : ""}`}
            onClick={() => {
              setAba(3);
              setTitulo("Relatório");
            }}
          >
            <span>Relatório</span>
          </button>
          <button
            className={`menuItem ${aba === 4 ? "active" : ""}`}
            onClick={() => {
              setAba(4);
              setTitulo("Relatório Geral");
            }}
          >
            <span>Relatório Geral</span>
          </button>
          {/*<button
            className={`menuItem ${aba === 5 ? "active" : ""}`}
            onClick={() => {
              setAba(5);
              setTitulo("Histórico de Ativiades");
            }}
          >
            <History />
            Histórico de Ativiades
          </button>*/}
          <button
            className={`menuItem ${aba === 6 ? "active" : ""}`}
            onClick={() => {
              setAba(6);
              setTitulo("Usuários");
            }}
          >
            <span>Usuarios</span>
          </button>
          <button
            className="logout"
            onClick={() => {
              localStorage.removeItem("token");
              //window.location.href = "/";
              navigate("/");
            }}
          >
            <Logout />
            Logout
          </button>

          <button
            tabIndex={-1}
            type="button"
            className="theme"
            onClick={() => setDarkMode(!darkMode)}
          >
            <CoffeBean />
            <span
              style={{
                maxWidth: darkMode ? "93%" : "0%",
                maxHeight: darkMode ? "93%" : "0%",
              }}
            >
              <CoffeBean />
            </span>
          </button>
        </aside>

        {showPopup && (
          <div className="-popup userPopup">
            <h3> Meu Usuário </h3>
            <h4>{user.email}</h4>
            <p>Alterar Senha</p>
            <CustomInput
              Style="Default"
              Type="text"
              Placeholder="Senha Atual"
              OnChange={(e) => setSenhaAtual(e.target.value)}
            />
            <CustomInput
              Style="Default"
              Type="text"
              Placeholder="Nova Senha"
              OnChange={(e) => setNovaSenha(e.target.value)}
            />

            <span className="error">{errorMsg}</span>

            <Button ClassName="icon" OnClick={() => AlterarSenha()}>
              <Add /> Alterar Senha
            </Button>

            <button className="close" onClick={() => setShowpoup(false)}>
              <Close />
            </button>
          </div>
        )}

        <div className={`wrapper ${menu ? "menuActive" : ""}`}>
          <div className="title -shadow-small">
            <h1> {titulo} </h1>
          </div>

          <div className="content -shadow-small">
            {aba === 1 && <Vendas darkMode={darkMode} />}
            {aba === 2 && <Movimentacao darkMode={darkMode} />}
            {aba === 3 && <Relatorio darkMode={darkMode} />}
            {aba === 5 && <Historico darkMode={darkMode} />}
          </div>
          {aba === 4 && <RelatorioGeral darkMode={darkMode} />}
          {aba === 6 && <Usuarios darkMode={darkMode} />}
        </div>
      </div>
    </div>
  );
}
